import { ResponsibleForm } from "../forms/ResponsibleForm";

const ResponsibleFormDrawer = ({ handleCloseDrawer, selected, isEditing, onlyVisual }: any) => {
    return (
        <ResponsibleForm
            handleCloseDrawer={handleCloseDrawer}
            selected={selected}
            isEditing={isEditing}
            onlyVisual={onlyVisual}
        />
    );
};

export { ResponsibleFormDrawer };